module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external "@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"
// module id = 6
// module chunks = 0 1